var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import * as nanoid from 'nanoid';
import { UIDReset } from 'react-uid';
import { isThisServer } from "./utils";
export var cacheControler = function (cache) {
    var counter = 0;
    var cachedValues = {};
    var cached = {};
    return {
        cache: cache,
        seed: nanoid().toLowerCase(),
        get: function (key) {
            return cachedValues[cached[key].key];
        },
        set: function (id, value) {
            var _a = cached[id], key = _a.key, ttl = _a.ttl;
            cache.set(key, value, ttl);
        },
        store: function (key, value) {
            cachedValues[key] = value;
            return this.assign(key, 0);
        },
        assign: function (key, ttl) {
            counter++;
            cached[counter] = { key: key, ttl: ttl };
            return counter;
        }
    };
};
var context = React.createContext({
    isServer: isThisServer(),
    hydrated: false,
});
var PrerenderedControler = (function (_super) {
    __extends(PrerenderedControler, _super);
    function PrerenderedControler() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hydrated: _this.props.hydrated || false,
        };
        return _this;
    }
    PrerenderedControler.prototype.componentDidMount = function () {
        if (this.props.hydrated) {
            this.setState({
                hydrated: false
            });
        }
    };
    PrerenderedControler.prototype.render = function () {
        var _a = this.props, children = _a.children, props = __rest(_a, ["children"]);
        return (React.createElement(UIDReset, null,
            React.createElement(context.Provider, { value: __assign({ isServer: isThisServer(), hydrated: false }, props, this.state) }, children)));
    };
    return PrerenderedControler;
}(React.Component));
export { PrerenderedControler };
;
export var PrerenderedContext = context;
export var PrerenderedControls = context.Consumer;
export var TemplateControl = React.createContext({
    variables: {},
    isServer: true,
    seed: ''
});
